'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as React from 'react';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import capitalize from "../utils/capitalize.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import { getSvgIconUtilityClass } from "./svgIconClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var color = ownerState.color,
    fontSize = ownerState.fontSize,
    classes = ownerState.classes;
  var slots = {
    root: ['root', color !== 'inherit' && "color".concat(capitalize(color)), "fontSize".concat(capitalize(fontSize))]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};
var SvgIconRoot = styled('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.color !== 'inherit' && styles["color".concat(capitalize(ownerState.color))], styles["fontSize".concat(capitalize(ownerState.fontSize))]];
  }
})(memoTheme(function (_ref) {
  var _theme$transitions, _theme$transitions$cr, _transitions, _theme$vars, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _theme$vars2, _palette2, _theme$vars4, _palette3, _theme$vars5;
  var theme = _ref.theme;
  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) === null || _theme$transitions === void 0 || (_theme$transitions$cr = _theme$transitions.create) === null || _theme$transitions$cr === void 0 ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_transitions = ((_theme$vars = theme.vars) !== null && _theme$vars !== void 0 ? _theme$vars : theme).transitions) === null || _transitions === void 0 || (_transitions = _transitions.duration) === null || _transitions === void 0 ? void 0 : _transitions.shorter
    }),
    variants: [{
      props: function props(_props) {
        return !_props.hasSvgAsChild;
      },
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: 'currentColor'
      }
    }, {
      props: {
        fontSize: 'inherit'
      },
      style: {
        fontSize: 'inherit'
      }
    }, {
      props: {
        fontSize: 'small'
      },
      style: {
        fontSize: ((_theme$typography = theme.typography) === null || _theme$typography === void 0 || (_theme$typography$pxT = _theme$typography.pxToRem) === null || _theme$typography$pxT === void 0 ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem'
      }
    }, {
      props: {
        fontSize: 'medium'
      },
      style: {
        fontSize: ((_theme$typography2 = theme.typography) === null || _theme$typography2 === void 0 || (_theme$typography2$px = _theme$typography2.pxToRem) === null || _theme$typography2$px === void 0 ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem'
      }
    }, {
      props: {
        fontSize: 'large'
      },
      style: {
        fontSize: ((_theme$typography3 = theme.typography) === null || _theme$typography3 === void 0 || (_theme$typography3$px = _theme$typography3.pxToRem) === null || _theme$typography3$px === void 0 ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
      }
    }].concat(_toConsumableArray(Object.entries(((_theme$vars2 = theme.vars) !== null && _theme$vars2 !== void 0 ? _theme$vars2 : theme).palette).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        value = _ref3[1];
      return value && value.main;
    }).map(function (_ref4) {
      var _palette, _theme$vars3;
      var _ref5 = _slicedToArray(_ref4, 1),
        color = _ref5[0];
      return {
        props: {
          color: color
        },
        style: {
          color: (_palette = ((_theme$vars3 = theme.vars) !== null && _theme$vars3 !== void 0 ? _theme$vars3 : theme).palette) === null || _palette === void 0 || (_palette = _palette[color]) === null || _palette === void 0 ? void 0 : _palette.main
        }
      };
    })), [{
      props: {
        color: 'action'
      },
      style: {
        color: (_palette2 = ((_theme$vars4 = theme.vars) !== null && _theme$vars4 !== void 0 ? _theme$vars4 : theme).palette) === null || _palette2 === void 0 || (_palette2 = _palette2.action) === null || _palette2 === void 0 ? void 0 : _palette2.active
      }
    }, {
      props: {
        color: 'disabled'
      },
      style: {
        color: (_palette3 = ((_theme$vars5 = theme.vars) !== null && _theme$vars5 !== void 0 ? _theme$vars5 : theme).palette) === null || _palette3 === void 0 || (_palette3 = _palette3.action) === null || _palette3 === void 0 ? void 0 : _palette3.disabled
      }
    }, {
      props: {
        color: 'inherit'
      },
      style: {
        color: undefined
      }
    }])
  };
}));
var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiSvgIcon'
  });
  var children = props.children,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'inherit' : _props$color,
    _props$component = props.component,
    component = _props$component === void 0 ? 'svg' : _props$component,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
    htmlColor = props.htmlColor,
    _props$inheritViewBox = props.inheritViewBox,
    inheritViewBox = _props$inheritViewBox === void 0 ? false : _props$inheritViewBox,
    titleAccess = props.titleAccess,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
    other = _objectWithoutProperties(props, _excluded);
  var hasSvgAsChild = /*#__PURE__*/ /*#__PURE__*/React.isValidElement(children) && children.type === 'svg';
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    color: color,
    component: component,
    fontSize: fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox: inheritViewBox,
    viewBox: viewBox,
    hasSvgAsChild: hasSvgAsChild
  });
  var more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  var classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/_jsxs(SvgIconRoot, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    as: component,
    className: clsx(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more), other), hasSvgAsChild && children.props), {}, {
    ownerState: ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /*#__PURE__*/_jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
SvgIcon.muiName = 'SvgIcon';
export default SvgIcon;